import FiltersMenu from '@/srp/FiltersMenu';
import { FILTER_DESKTOP_SCROLL_CONTAINER_ID } from '@/srp/FiltersMenu/constants';
import styles from './Filters.module.css';
import { Aside } from './Filters.styles';
import AppliedFilters from '../AppliedFilters';

export default function Filters() {
  return (
    <Aside
      data-testid="filters-aside"
      className={styles.scrollContainer}
      id={FILTER_DESKTOP_SCROLL_CONTAINER_ID}
    >
      <div className="sticky top-0 z-[10]">
        <AppliedFilters />
      </div>
      <FiltersMenu />
    </Aside>
  );
}
